/* Clearer landing page behaviour: accordion, UTM passthrough on CTAs, analytics event, mobile carousels.
   Loaded once; safe to include from multiple sections (guarded). */
(function () {
  if (window.__clearerLpInit) return;
  window.__clearerLpInit = true;

  function init() {
    /* FAQ accordion (event delegation, works with editor re-renders) */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.clearer-lp .accordion-button');
      if (!btn) return;
      var wasOpen = btn.getAttribute('aria-expanded') === 'true';
      var scope = btn.closest('.faq-list') || document;
      scope.querySelectorAll('.accordion-button').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      btn.setAttribute('aria-expanded', String(!wasOpen));
    });

    /* UTM / click-id passthrough onto every CTA link */
    var params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];
    function decorate(link) {
      try {
        var src = new URL(window.location.href);
        var url = new URL(link.href, window.location.origin);
        params.forEach(function (p) {
          var v = src.searchParams.get(p);
          if (v && !url.searchParams.has(p)) url.searchParams.set(p, v);
        });
        if (!url.searchParams.has('landing_page')) url.searchParams.set('landing_page', 'floater_protocol_shopify');
        link.href = url.toString();
      } catch (err) { /* leave link as-is */ }
    }
    document.querySelectorAll('.clearer-lp [data-cta]').forEach(decorate);

    /* Analytics event on CTA click */
    document.addEventListener('click', function (e) {
      var cta = e.target.closest('.clearer-lp [data-cta]');
      if (!cta) return;
      var label = (cta.textContent || '').trim().replace(/\s+/g, ' ');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'clearer_landing_cta_click', cta_label: label, landing_page: 'floater_protocol_shopify' });
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'select_promotion', { promotion_id: 'floater_protocol_shopify', creative_name: label });
      }
    });
  }

  /* Mobile carousels (mechanism + ingredient cards), added 2026-09-27.
     CSS makes the track scroll sideways below 750px. This adds position dots,
     carousel ARIA and keyboard focus only while the track actually scrolls,
     so desktop grids stay plain. */
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function initCarousel(root) {
    if (root.__ceCarousel) return;
    var track = root.querySelector('[data-ce-carousel-track]');
    var dotsWrap = root.querySelector('[data-ce-carousel-dots]');
    if (!track || !dotsWrap) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    root.__ceCarousel = true;

    var label = root.getAttribute('data-ce-carousel-label') || 'Cards';
    var active = false;
    var current = -1;
    var dots = [];
    var ticking = false;
    var slideAttrs = ['role', 'aria-roledescription', 'aria-label'];

    function step() {
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }
    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }
    function scrollable() {
      return maxScroll() > 4 && getComputedStyle(track).overflowX !== 'visible';
    }
    function indexFromScroll() {
      if (track.scrollLeft >= maxScroll() - 2) return slides.length - 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step())));
    }
    function paint() {
      ticking = false;
      var i = indexFromScroll();
      if (i === current) return;
      current = i;
      dots.forEach(function (d, n) {
        if (n === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
    function onScroll() {
      if (!active || ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }
    function go(i) {
      track.scrollTo({ left: Math.min(i * step(), maxScroll()), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    function activate() {
      active = true;
      track.setAttribute('tabindex', '0');
      track.setAttribute('role', 'region');
      track.setAttribute('aria-roledescription', 'carousel');
      track.setAttribute('aria-label', label);
      dotsWrap.innerHTML = '';
      dots = slides.map(function (slide, i) {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ce-carousel__dot';
        b.setAttribute('aria-label', 'Show card ' + (i + 1) + ' of ' + slides.length);
        b.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(b);
        return b;
      });
      dotsWrap.hidden = false;
      current = -1;
      paint();
    }
    function deactivate() {
      active = false;
      ['tabindex', 'role', 'aria-roledescription', 'aria-label'].forEach(function (a) { track.removeAttribute(a); });
      slides.forEach(function (slide) {
        slideAttrs.forEach(function (a) { slide.removeAttribute(a); });
      });
      dotsWrap.hidden = true;
      dotsWrap.innerHTML = '';
      dots = [];
    }
    function sync() {
      var should = scrollable();
      if (should && !active) activate();
      else if (!should && active) deactivate();
      else if (active) { current = -1; paint(); }
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    else window.addEventListener('resize', sync);
    sync();

    /* Theme editor: selecting a card block brings it into view. */
    root.__ceCarouselGo = function (el) {
      var i = slides.indexOf(el);
      if (i > -1 && active) go(i);
    };
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-ce-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  } else {
    init();
    initCarousels();
  }
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-ce-carousel]');
    if (root && root.__ceCarouselGo) root.__ceCarouselGo(e.target);
  });
})();
